import * as net from "../vipa/net";

export class Case {
    constructor() {
        $("#variants").on("click", ".button-add_to_cart", this.#click.bind(this));
        $("#favourites").on("click", ".button-add_to_cart", this.#click.bind(this));
    }

    #click(event: JQuery.ClickEvent) {
        let product_id = $(event.currentTarget).data("id");
        let quantity = (<HTMLInputElement>$(`#quantity-${product_id}`)[0])
            .value;
        let data = {
            jsonrpc: "2.0",
            id: null,
            product_id: product_id,
            quantity: quantity
        }
        let url;
        if (globalThis.lang) {
            url = `/${globalThis.lang}/j/add-to-cart/`;
        } else {
            url = "/j/add-to-cart/";
        }
        net.postJSON(url, data, this.#showAdded.bind(this))
            .fail(this.#showError.bind(this));

        // Trace on analytics
        window.sa_event("add_cart_item", {"variant": product_id});
    }

    #showAdded(response: JQuery.PlainObject): void {
        let cart_count = $("#base-cartCount");
        cart_count.text(response.result.cart_count);

        let modal = $("#modal-small");
        let content = $("#modal-small div");
        content.html(response.result.html);
        modal.foundation("open");
    }

    #showError(response: JQuery.jqXHR): void {
        let modal = $("#modal-small");
        let content = $("#modal-small div");

        // TODO: display error on wrong quantity

        content.html(response.responseJSON.error);
        modal.foundation("open");
    }
}
